import type { ClaimOutcome, InvitationOutcome } from '@forecastify/shared';
import type { Translate } from '../../i18n';

/** The sentence for each way accepting or claiming an invitation can end. */
export function outcomeMessage(t: Translate, outcome: InvitationOutcome): string {
  /* One `t()` per branch, literal keys. */
  if (outcome === 'wrong_account') return t('invite.accept.wrongAccount');
  if (outcome === 'expired') return t('invite.accept.expired');
  if (outcome === 'revoked') return t('invite.accept.revoked');
  if (outcome === 'accepted') return t('invite.accept.used');
  return t('invite.accept.unknown');
}

export function claimMessage(t: Translate, outcome: ClaimOutcome): string {
  /* One `t()` per branch, literal keys. */
  if (outcome === 'already_registered') return t('invite.claim.already');
  if (outcome === 'weak_password') return t('invite.claim.weak');
  if (outcome === 'expired') return t('invite.accept.expired');
  if (outcome === 'revoked') return t('invite.accept.revoked');
  if (outcome === 'accepted') return t('invite.accept.used');
  if (outcome === 'unknown') return t('invite.accept.unknown');
  return t('error.unavailable');
}
